<template>
  <div class="container">
    <div class="theme">热门推荐</div>

    <!-- <div class="goodList">
      <div
        @click="goDetail(item)"
        v-for="(item, index) in goodList"
        :key="index"
        class="item good-item"
      >
        <div class="pictrue">
          <img :src="item.image" class="image" />
        </div>
        <div class="underline">
          <div class="text">
            <div class="line1">{{ item.store_name }}</div>
            <div class="money">
              <div class="num">￥{{ item.price }}</div>
              <div class="add-cart"></div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="zoumadeng-container">
      <div
        type="card"
        class="zoumadeng"
        v-if="!isTyrvaya"
      >
        <div v-for="(item, index) in goodList" :key="index" v-if="item.id!=5261">
          <div class="zouma-item" @click="goDetail(item)">
            <!--<div class="zouma-index">
              <span class="zouma-total">{{ goodList.length }}</span
              >-<span class="zouma-now">{{ index + 1 }}</span>
            </div>-->
            <div class="zouma-item-image">
              <img :src="item.image" />
            </div>
            <div class="zouma-item-content">
              <div class="zouma-name">{{ item.store_name }}</div>
              <div class="zouma-info">{{ item.store_info }}</div>
              <div class="zouma-buy">
                <div class="zouma-price">￥{{ item.price }}</div>
                <div class="zouma-add" @click.stop="addCart(item)" v-if="item.id == 5254|| item.id ==5255|| item.id ==5256 || item.id==5257">
                  领券购买
                </div>
                <div class="zouma-add" @click.stop="addCart(item)" v-else>
                  加入购物车
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        type="card"
        class="zoumadeng"
        v-else
      >
        <div v-for="(item, index) in goodList" :key="index" v-if="item.id==5261">
          <div class="zouma-item" @click="goDetail(item)">
            <div class="zouma-index">
              <span class="zouma-total">{{ goodList.length }}</span
              >-<span class="zouma-now">{{ index + 1 }}</span>
            </div>
            <div class="zouma-item-image">
              <img :src="item.image" />
            </div>
            <div class="zouma-item-content">
              <div class="zouma-name">{{ item.store_name }}</div>
              <div class="zouma-info">{{ item.store_info }}</div>
              <div class="zouma-buy">
                <div class="zouma-price">￥{{ item.price }}</div>
                <div class="zouma-add" @click.stop="addCart(item)" v-if="item.id == 5254|| item.id ==5255|| item.id ==5256 || item.id==5257">
                  领券购买
                </div>
                <div class="zouma-add" @click.stop="addCart(item)" v-else>
                  加入购物车
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="foot">厂家授权|官方正品|境外直邮|闪电发货</div> -->
    <div class="mask" @click.stop="closeFollow" v-if="isShowFollow"></div>
    <div class="follow-image" v-if="isShowFollow">
      <img :src="followUrl" class="image" />
    </div>
  </div>
</template>
<script>
import { getUserFollow } from "@api/user";
import { follow } from "@api/public";
import { mapGetters } from "vuex";
import toLogin from "@libs/login";
export default {
  name: "GoodList",
  props: {
    goodList: {
      type: Array,
      default: () => []
    },
    isSort: {
      type: Boolean,
      default: true
    },
    isTyrvaya: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["isLogin"])
  },
  data: function() {
    return {
      isFollowed: false,
      followUrl: "",
      isShowFollow: false
    };
  },
  mounted() {
    console.log("isLofn");
    console.log(this.isLogin);
    if (this.isLogin) {
      console.log("?zheyexing");
      follow().then(res => {
        console.log(res);
        this.followUrl = res.data.path;
      });
    }
  },
  methods: {
    // 商品详情跳转
    async goDetail(item) {
      if (!this.isLogin) {
        console.log("mei");
        return toLogin();
      }
      let followed = await getUserFollow();
      console.log(followed);
      this.isFollowed = followed.data.subscribe;
      if (!this.isFollowed) {
        return (this.isShowFollow = true);
      }
      if (item.activity && item.activity.type === "1") {
        this.$router.push({
          path:
            "/activity/seckill_detail/" +
            item.activity.id +
            "/" +
            item.activity.time +
            "/1"
        });
      } else if (item.activity && item.activity.type === "2") {
        this.$router.push({
          path: "/activity/dargain_detail/" + item.activity.id
        });
      } else if (item.activity && item.activity.type === "3") {
        this.$router.push({
          path: "/activity/group_detail/" + item.activity.id
        });
      } else {
        this.$router.push({ path: "/detail/" + item.id });
      }
    },
    addCart(item) {
      console.log("?");
      this.$router.push({ path: `/detail/${item.id}?open=true` });
    },
    closeFollow() {
      this.isShowFollow = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  background-image: url("../../assets/moblie/images/titlebackground.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 2px 10px;
  padding-left: 0;
  box-sizing: border-box;
  margin-top: 30px;
  position: relative;
}
.el-carousel__container {
  height: 4.3rem;
}
.el-carousel__item {
  .zouma-add {
    display: none;
  }
}
.is-active {
  .zouma-add {
    display: block;
  }
}
.theme {
  color: rgb(92, 110, 243);
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  margin: 2px 0 10px 0;
}
.goodList {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 120px;
}
.good-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  width: 32%;
  padding: 10px 0;
}
.zoumadeng-container {
  width: 100%;
}
.hint {
  position: absolute;
  left: 0;
  width: 0.3rem;
  top: 0.3rem;
  padding: 0.3rem 0.1rem 0.3rem 0;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  background-color: rgb(108, 139, 221);
  color: #fff;
  z-index: 9;
}
.el-carousel__item--card.is-active {
  width: 88%;
  margin-left: -1.2rem;
  margin-top: 0.2rem;
}
.zoumadeng {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.zouma-item {
  width: 100%;
  height: 3rem;
  text-align: center;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 0.1rem 0 #888888;
  display: flex;
  align-items: flex-start;
  padding: 0.2rem;
}
.zouma-index {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  font-weight: 600;
  display: flex;
  align-items: flex-start;
  color: rgb(197, 202, 233);
}
.zouma-total {
  font-size: 0.5rem;
}
.zouma-item-image {
  width: 3rem;
  height: 2.5rem;
}
.zouma-item-image img {
  width: 100%;
  height: 100%;
}
.zouma-item-content {
  margin-left: 0.2rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 77%;
}
.zouma-info {
  margin-top: 0.1rem;
  color: rgb(207, 207, 207);
  flex-grow: 1;
  width: 100%;
  /* height: 1rem; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.zouma-buy {
  display: flex;
  align-items: center;
}
.zouma-price {
  flex-grow: 1;
  text-align: left;
  color: rgb(224, 12, 12);
  font-weight: 600;
  font-size: 0.35rem;
}
.zouma-add {
  background-color: rgb(109, 138, 221);
  border-radius: 20px;
  padding: 0.1rem 0.2rem;
  color: #fff;
}
.zouma-name {
  font-size: 0.3rem;
  font-weight: 500;
  width: 75%;
}
.good-item .pictrue img {
  width: 80px;
  height: 100px;
}
.good-item .underline {
  width: 100%;
  padding: 2px 10px;
}
.good-item .underline .text {
  width: 100%;
}
.good-item .underline .text .line1 {
  width: 100%;
  padding: 0 4px;
  box-sizing: border-box;
}
.money {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: rgb(215, 28, 8);
}
.add-cart {
  width: 20px;
  height: 20px;
  background-image: url("../../assets/moblie/images/shoppingcart.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.saled {
  color: rgb(168, 63, 63);
}
.foot {
  width: 100%;
  color: rgb(97, 106, 222);
  font-size: 14px;
  margin: 4px 0;
  text-align: center;
}
.follow-image {
  position: fixed;
  width: 50%;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 9;
}
.image {
  width: 100%;
}
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  z-index: 5;
}
</style>
